import React from "react";
import RoleToggle from "../../components/RoleToggle";
import { useSearchParams } from "react-router-dom";
import RouteListManagement from "./_components/RouteListManagement";
import ZoneManagement from "./_components/ZoneManagement";
import NotificationMange from "./_components/NotificationMange";
import DocumentDesigner from "../DocumentDesigner";
import LocationTab from "./_components/Location/LocationTab";
// import RadiusManagement from "./_components/RadiusManagement";
// import RadiusPricingManagement from "./_components/RadiusManagementPricing";

const roles = ["Notification", "Route", "Zone", "Template", "Location"/*, "Dark Store Radius", "Dark Store Radius Pricing"*/];
const Settings: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Notification";

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  return (
    <div className="p-4 pt-0 space-y-4 max-w-[95rem] mx-auto">
      <div className="flex flex-col justify-center gap-4 items-center">
        <h1 className="text-2xl text-[#212121] tracking-[-0.5px]">Settings</h1>
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={handleRoleChange}
        />
      </div>

      <div className={activeRole === "Template" ? "w-full mx-auto py-0" : " [@media(min-width:1920px)]:w-11/12 [@media(min-width:1536px)]:w-11/12  w-full mx-auto p-6 py-0  "}>
        {activeRole === "Notification" && <NotificationMange />}
        {activeRole === "Route" && <RouteListManagement />}
        {activeRole === "Zone" && <ZoneManagement />}
        {activeRole === "Template" && <DocumentDesigner />}
        {activeRole === "Location" && <LocationTab />}
        {/* {activeRole === "Dark Store Radius" && <RadiusManagement /> } */}
        {/* {activeRole === "Dark Store Radius Pricing" && <RadiusPricingManagement /> } */}
      </div>
    </div>
  );
};
export default Settings;
